export const EVENTS = {
  SHOW_SNACKBAR: "snackbar",
  QUERY: "query",
  UPDATE_CALENDAR: "update-calendar",
} as const;

export type EventType = (typeof EVENTS)[keyof typeof EVENTS];
